import {
  Modal,
  Box,
  Typography,
  IconButton,
  TextField,
  Button,
  Grid,
} from "@mui/material"
import { z } from "zod"
import ClearIcon from "@mui/icons-material/Clear"
import { useAddModel } from "@/hooks/useAddModel"
import { useEffect } from "react"

const BrandSchema = z.object({
  name: z.string().min(3),
})

const AddBrandModal = ({ open, onClose }) => {
  const {
    errors,
    openDialog,
    isSubmitting,
    selectedRow,
    register,
    handleSubmit,
    onSubmit,
    handleReset,
    defaultOnClose,
    reset,
  } = useAddModel("brand", BrandSchema)

  useEffect(() => {
    if (selectedRow) {
      reset({
        name: selectedRow.name,
      })
    }
  }, [selectedRow, reset])

  return (
    <Modal open={open ? open : openDialog} onClose={defaultOnClose}>
      <div className="w-[95vw] sm:w-[90vw] md:w-[500px] mx-auto mt-24 bg-white rounded-lg shadow-md">
        {/* Header */}
        <div className="flex items-center justify-between bg-[#f6f7f9] px-4 py-3 rounded-t-lg">
          <h2 className="font-semibold text-black text-[16px] md:text-[18px]">
            {selectedRow ? "Update Brand" : "Add New Brand"}
          </h2>
          <IconButton
            aria-label="remove"
            size="small"
            onClick={onClose ? onClose : defaultOnClose}
          >
            <ClearIcon />
          </IconButton>
        </div>

        {/* Form Body */}
        <form onSubmit={handleSubmit(onSubmit)} noValidate className="p-4">
          {/* Name Field */}
          <div className="mb-4">
            <TextField
              fullWidth
              label="Name"
              defaultValue={selectedRow?.name || ""}
              error={!!errors.name}
              helperText={errors.name?.message}
              {...register("name")}
            />
          </div>

          {/* Button Row */}
          <div className="flex justify-end items-center gap-2 mt-2 flex-wrap">
            <Button
              onClick={handleReset}
              variant="text"
              className="capitalize rounded-md font-medium text-[13px] py-[11px] px-[30px] w-full sm:w-auto"
            >
              Reset
            </Button>

            <Button
              onClick={onClose ? onClose : defaultOnClose}
              variant="outlined"
              color="error"
              className="capitalize rounded-md font-medium text-[13px] py-[11px] px-[30px] w-full sm:w-auto"
            >
              Cancel
            </Button>

            <Button
              type="submit"
              disabled={isSubmitting}
              variant="contained"
              className="capitalize rounded-md font-medium text-[13px] py-[11px] px-[30px] text-white w-full sm:w-auto"
            >
              {selectedRow ? "Update" : "Create"}
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  )
}

export default AddBrandModal
